var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconParkOutlineMedicalFiles(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 74,
    viewBox: "0 0 75 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9583 64.75H14.375C13.5572 64.75 12.773 64.4252 12.1947 63.8469C11.6165 63.2687 11.2916 62.4844 11.2916 61.6667V12.3333C11.2916 11.5156 11.6165 10.7313 12.1947 10.1531C12.773 9.57485 13.5572 9.25 14.375 9.25H57.5416C58.3594 9.25 59.1436 9.57485 59.7219 10.1531C60.3001 10.7313 60.625 11.5156 60.625 12.3333V30.0625",
    stroke: "#004B6B",
    strokeWidth: 6.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9805 41.625C60.6959 41.625 63.7083 44.5234 63.7083 48.1C63.7083 52.7559 59.222 56.7334 56.9805 58.8917C55.4861 60.3306 53.6176 61.7695 51.375 63.2084C49.1323 61.7695 47.2638 60.3306 45.7695 58.8917C43.5263 56.7334 39.0416 52.7559 39.0416 48.1C39.0416 44.5234 42.054 41.625 45.7695 41.625C48.1082 41.625 50.1694 42.7751 51.375 44.5203C52.0049 43.6197 52.8442 42.8857 53.8206 42.3813C54.7971 41.877 55.8815 41.6174 56.9805 41.625Z",
    stroke: "#004B6B",
    strokeWidth: 6.16667,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.625 21.5833H48.2917",
    stroke: "#004B6B",
    strokeWidth: 6.16667,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconParkOutlineMedicalFiles);
export default __webpack_public_path__ + "static/media/icon-park-outline_medical-files.ca26bff11a36547cd439128578014750.svg";
export { ForwardRef as ReactComponent };